import { FC } from 'react';
import { StoryblokRichtext } from 'storyblok-rich-text-react-renderer-ts';

import { Quote } from './Quote';
import { Container, ImageContainer } from './QuoteContainers';

interface QuoteGroupProps {
  author: StoryblokRichtext;
  image: StoryblokImage;
  text: StoryblokRichtext;
  thumbnail: StoryblokImage;
}

export const QuoteGroup: FC<QuoteGroupProps> = ({
  author,
  image,
  text,
  thumbnail,
}) => {
  return image?.filename ? (
    <ImageContainer image={image}>
      <Quote author={author} text={text} thumbnail={thumbnail} />
    </ImageContainer>
  ) : (
    <Container>
      <Quote author={author} text={text} thumbnail={thumbnail} />
    </Container>
  );
};
